export default __webpack_public_path__ + "static/media/en_order_02.14b3f62e.png";